import { makeZodI18nMap } from 'zod-i18n-map';
import { setErrorMap } from 'zod';

export function setupZod() {
  setErrorMap(makeZodI18nMap({ handlePath: false }));
}
